export const QBO_PNL_GROUPS = [
    'Income',
    'OtherIncome',
    'COGS',
    'Expenses',
    'OtherExpenses',
    'GrossProfit',
    'NetOperatingIncome',
    'NetOtherIncome',
    'NetIncome',
    'GrandTotal',
];
export function isQboPnLGroup(value) {
    return QBO_PNL_GROUPS.some((group) => group === value);
}
const GROUP_BUCKET = {
    Income: 'income',
    OtherIncome: 'income',
    COGS: 'expense',
    Expenses: 'expense',
    OtherExpenses: 'expense',
    GrossProfit: 'ignore',
    NetOperatingIncome: 'ignore',
    NetOtherIncome: 'ignore',
    NetIncome: 'ignore',
    GrandTotal: 'ignore',
};
export function classifyPnLSection(section) {
    if (section.group) {
        const bucket = GROUP_BUCKET[section.group];
        if (bucket === 'ignore')
            return { bucket, via: 'computed-subtotal' };
        return { bucket, via: 'group' };
    }
    const labels = [section.title, section.summary?.label ?? ''].map((label) => label.trim());
    if (labels.every((label) => label.length === 0)) {
        return { bucket: 'ignore', via: 'empty' };
    }
    const isComputedSubtotal = labels.some((label) => /^(?:total\s+)?(?:gross profit|net (?:operating |ordinary |other )?income(?: \(loss\))?)$/i.test(label));
    if (isComputedSubtotal)
        return { bucket: 'ignore', via: 'computed-subtotal' };
    const descriptor = labels.join(' ');
    if (/expense|\bcost of (?:goods sold|revenue|sales)\b|\bcogs\b/i.test(descriptor)) {
        return { bucket: 'expense', via: 'title' };
    }
    if (/income|revenue/i.test(descriptor))
        return { bucket: 'income', via: 'title' };
    return { bucket: 'ignore', via: 'unrecognized' };
}
export function isOperatingExpenseSection(section) {
    return section.group === 'Expenses';
}
export function isOperatingIncomeSection(section) {
    return section.group === 'Income';
}
//# sourceMappingURL=pnlSection.js.map